module.exports = __webpack_public_path__ + "img/hn.167a9f88.png";